import { useStaticQuery, graphql } from "gatsby";

/**
 * Returns the link (path) of the first published page using the Droidal Page
 * template, selected as the oldest published page (date ascending).
 * Returns null when no Droidal page exists.
 */
const useDroidalLink = () => {
	const data = useStaticQuery(graphql`
		query DroidalLinkQuery {
			allWpPage(
				filter: {
					template: { templateName: { eq: "Droidal Page" } }
					status: { eq: "publish" }
				}
				sort: { fields: date, order: ASC }
				limit: 1
			) {
				nodes {
					link
				}
			}
		}
	`);

	return data?.allWpPage?.nodes?.[0]?.link || null;
};

export default useDroidalLink;
